export default (o, c, d) => {
  c.prototype.isStartOfDay = function () {
    return this.hour() === 0 && this.minute() === 0 && this.second() === 0 && this.millisecond() === 0
  }
}
